import React from 'react';

import Loading from 'components/atoms/Loading';
import Carousel, { PrevArrow, NextArrow } from 'components/organisms/Carousel';
import Container from 'components/organisms/Container';
import SimpleReportCard from 'components/organisms/SimpleReportCard';
import TitleSection from 'components/organisms/TitleSection';

export interface ReportCardProps {
  date: string;
  title: string[];
  subTitle: string;
  description: string;
  bntText: string;
  background: string;
  hasLogin?: boolean;
  isShowDownload?: boolean;
  handleDownload: () => void;
}

interface ReportListHomeProps {
  reportList?: ReportCardProps[];
  title: string;
  viewMoreText?: string;
  href?: string;
  target?: string;
  loginSSOLink?: string;
  loading?: boolean;
}

const settingCarousel = {
  dots: true,
  arrows: true,
  dotsClass: 'slick-dots o-carousel_dots',
  slidesToShow: 5,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  infinite: false,
  cssEase: 'ease-in-out',
  customPaging() {
    return (
      <span className="o-carousel_dots_main" />
    );
  },
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        arrows: false,
      },
    },
  ],
};

const ReportListHome: React.FC<ReportListHomeProps> = ({
  reportList,
  title,
  viewMoreText,
  href,
  target,
  loginSSOLink,
  loading,
}) => (
  <div className="t-reportListHome">
    <Container>
      <TitleSection title={title} viewMoreText={viewMoreText} href={href} target={target}>
        {loading ? <Loading isShow /> : reportList && reportList.length > 0 && (
          <div className="t-reportListHome_list">
            <Carousel settings={settingCarousel}>
              {reportList.map((item, idx) => (
                <div className="t-reportListHome_item" key={`report-${idx.toString()}`}>
                  <SimpleReportCard
                    date={item.date}
                    title={item.title}
                    subTitle={item.subTitle}
                    description={item.description}
                    bntText={item.bntText}
                    background={item.background}
                    hasLogin={item.hasLogin}
                    loginSSOLink={loginSSOLink}
                    handleDownload={item.handleDownload}
                    isShowDownload={item.isShowDownload}
                  />
                </div>
              ))}
            </Carousel>
          </div>
        )}
      </TitleSection>
    </Container>
  </div>
);

ReportListHome.defaultProps = {
  reportList: undefined,
  viewMoreText: '',
  href: '/',
  target: '_self',
  loginSSOLink: undefined,
  loading: false,
};

export default ReportListHome;
